import DepartmentSelect from '@src/components/DepartmentSelect/DepartmentSelect';
import { contactAssignmentActions } from '@src/reducers/contactAssignment';
import { contactAssignedSelector } from '@src/selectors/contactAssignment';
import { isDepartmentModuleActiveSelector } from '@src/selectors/departments';
import { Department, DepartmentState } from '@src/types';
import {
  ContactAssignmentOptions,
  ContactAssignmentType,
} from '@src/types/contactAssignment';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type AssignContactToDepartmentProps = {
  contactId: string;
  readOnly?: boolean;
};

const AssignContactToDepartment: React.FC<AssignContactToDepartmentProps> = ({
  contactId,
  readOnly,
}) => {
  const dispatch = useDispatch();
  const contactAssignment = useSelector(contactAssignedSelector(contactId));
  const [assignContactToDep, setAssignContactToDep] = useState<Department>(
    {} as Department
  );

  const isDepartmentModuleActive = useSelector(
    isDepartmentModuleActiveSelector
  );

  const hasContactAssignment = useMemo(
    () =>
      !!contactAssignment?.id &&
      contactAssignment.type !== ContactAssignmentOptions.UNASIGNED,
    [contactAssignment]
  );

  useEffect(() => {
    if (contactAssignment?.type === ContactAssignmentOptions.DEPARTMENT)
      setAssignContactToDep({
        departmentId: contactAssignment.id,
        name: contactAssignment.description,
      } as Department);
  }, [contactAssignment]);

  const handleContactAssignmentToDep = (department: Department) => {
    if (
      department?.departmentId &&
      department?.departmentId !== contactAssignment?.id
    ) {
      setAssignContactToDep(department);
      dispatch(
        contactAssignmentActions.assignContact({
          contactId,
          assignedTo: {
            id: department.departmentId,
            description: department.name,
            type: ContactAssignmentOptions.DEPARTMENT as ContactAssignmentType,
          },
          replace: hasContactAssignment,
        })
      );
    }
  };

  return (
    <>
      <DepartmentSelect
        withStatus={false}
        value={assignContactToDep as Department}
        onChange={(_, dep) => handleContactAssignmentToDep(dep as Department)}
        filterOptions={dep =>
          dep.type !== 'STANDARD' && dep.state !== DepartmentState.INACTIVE
        }
        disableInactiveOptions
        disabled={!isDepartmentModuleActive || readOnly}
      />
    </>
  );
};

export default AssignContactToDepartment;
